// 3rd-party modules
import { createBrowserHistory } from 'history';

export default createBrowserHistory({ window });
